export const toReservedPooledCount = (value: number): number => Math.abs(value)
